var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect } from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { LoadingUserRow, UserRow } from './UserRow';
import UserTableBlankState from './UserTableBlankState';
import UserTableErrorState from './UserTableErrorState';
import UserTableAllFilteredState from './UserTableAllFilteredState';
var useStyles = makeStyles(function () { return ({
    root: {
        marginTop: '16px'
    }
}); });
export default function LicenseComplianceTable(_a) {
    var filterState = _a.filterState, onReloadUsersClick = _a.onReloadUsersClick, onFilter = _a.onFilter, paginationState = _a.paginationState, userRequestState = _a.userRequestState;
    var classes = useStyles();
    var _b = __read(React.useState([]), 2), filteredUsers = _b[0], setFilteredUsers = _b[1];
    var status = userRequestState.status, error = userRequestState.error, users = userRequestState.result;
    // Search happens here
    useEffect(function () {
        if (!users)
            return;
        var filteredUsers = users;
        if (filterState.search) {
            filteredUsers = users.filter(function (user) {
                var matched;
                if (user.firstName && (user === null || user === void 0 ? void 0 : user.firstName.toLowerCase().includes(filterState.search.toLowerCase()))) {
                    matched = true;
                }
                if ((user === null || user === void 0 ? void 0 : user.lastName) && (user === null || user === void 0 ? void 0 : user.lastName.toLowerCase().includes(filterState.search.toLowerCase()))) {
                    matched = true;
                }
                if (user === null || user === void 0 ? void 0 : user.email.toLowerCase().includes(filterState.search.toLowerCase())) {
                    matched = true;
                }
                return matched;
            });
        }
        if (filterState.licenseTypes.length) {
            filteredUsers = filteredUsers.filter(function (user) { return user.licenses.some(function (l) { return filterState.licenseTypes.indexOf(l) !== -1; }); });
        }
        setFilteredUsers(filteredUsers);
        onFilter(filteredUsers);
    }, [users, filterState]);
    if (status === 'loading') {
        return (React.createElement(Grid, { container: true, className: classes.root }, Array.from(Array(paginationState.pageSize).keys()).map(function (i) { return (React.createElement(LoadingUserRow, { key: i })); })));
    }
    if (error) {
        return React.createElement(UserTableErrorState, { onClick: onReloadUsersClick });
    }
    if (users && !users.length)
        return React.createElement(UserTableBlankState, null);
    filteredUsers.sort(function (a, b) {
        if (filterState.sortDesc) {
            return a.email.localeCompare(b.email) * -1;
        }
        return a.email.localeCompare(b.email);
    });
    var pagedUsers = filteredUsers.slice((paginationState.currentPage - 1) * paginationState.pageSize, paginationState.currentPage * paginationState.pageSize);
    if (pagedUsers.length === 0) {
        return React.createElement(UserTableAllFilteredState, null);
    }
    return (React.createElement(Grid, { container: true, className: classes.root }, pagedUsers.map(function (user) { return (React.createElement(UserRow, { user: user, key: user.email })); })));
}
//# sourceMappingURL=LicenseComplianceTable.js.map